import { RiArticleLine } from "react-icons/ri";
import { VscFolderLibrary } from "react-icons/vsc";
import { GiBlackBook } from "react-icons/gi";

export const publications = [
  {
    icon: <RiArticleLine />,
    name: "Articles",
    link: "https://codesweetly.com/",
  },
  {
    icon: <VscFolderLibrary />,
    name: "Libraries",
    link: "https://www.npmjs.com/~codesweetly",
  },
  {
    icon: <GiBlackBook />,
    name: "Books",
    link: "https://www.amazon.com/stores/Oluwatobi-Sofela/author/B09L1FBX8Q?tag=codesweetly00-20",
  },
];
